module.exports = __webpack_public_path__ + "img/perforaciones_3-4_512.30a47865.webp";